import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { QuoteRequest, Quote } from '../types';

interface QuoteRequestsState {
  requests: QuoteRequest[];
  setRequests: (requests: QuoteRequest[]) => void;
  addRequest: (request: QuoteRequest) => void;
  updateRequest: (id: string, request: Partial<QuoteRequest>) => void;
  deleteRequest: (id: string) => void;
}

interface QuotesState {
  quotes: Quote[];
  setQuotes: (quotes: Quote[]) => void;
  addQuote: (quote: Quote) => void;
  updateQuote: (id: string, quote: Partial<Quote>) => void;
  deleteQuote: (id: string) => void;
}

export const useQuoteRequestsStore = create<QuoteRequestsState>()(
  persist(
    (set) => ({
      requests: [],
      setRequests: (requests) => set({ requests }),
      addRequest: (request) => 
        set((state) => ({ 
          requests: [...state.requests, request] 
        })),
      updateRequest: (id, request) =>
        set((state) => ({
          requests: state.requests.map((r) => 
            r.id === id ? { ...r, ...request } : r
          ),
        })),
      deleteRequest: (id) =>
        set((state) => ({
          requests: state.requests.filter((r) => r.id !== id),
        })),
    }),
    {
      name: 'quote-requests-storage',
    }
  )
);

export const useQuotesStore = create<QuotesState>()(
  persist(
    (set) => ({
      quotes: [],
      setQuotes: (quotes) => set({ quotes }),
      addQuote: (quote) => 
        set((state) => ({ 
          quotes: [...state.quotes, quote] 
        })),
      updateQuote: (id, quote) =>
        set((state) => ({
          quotes: state.quotes.map((q) => 
            q.id === id ? { ...q, ...quote } : q
          ),
        })),
      deleteQuote: (id) =>
        set((state) => ({
          quotes: state.quotes.filter((q) => q.id !== id),
        })),
    }),
    {
      name: 'quotes-storage',
    }
  )
); 